import { render, staticRenderFns } from "./PlansCombo.vue?vue&type=template&id=8c89bafa&"
import script from "./PlansCombo.vue?vue&type=script&lang=js&"
export * from "./PlansCombo.vue?vue&type=script&lang=js&"
import style0 from "./PlansCombo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports